<template>
  <div class="container">
    <donut-page-title title="Authorize Google Calendar" />
    <div class="separator m-vx2" />
    <a class="button sign-in" :href="props.authPath">Authorize</a>
    <div v-if="props.registeredEmails.length" class="m-tx4">
      <div class="t-lg bold">Existing Google Calendar Authorizations</div>
      <div v-for="(email, i) in props.registeredEmails" :key="i" class="t m-t">{{ email }}</div>
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    registeredEmails: { type: Array, required: true },
    authPath: { type: String, required: true },
  });
</script>
